import { render } from "./ChangePasswordSelection.vue?vue&type=template&id=60c008cc&scoped=true"
import script from "./ChangePasswordSelection.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSelection.vue?vue&type=script&lang=js"

import "./ChangePasswordSelection.vue?vue&type=style&index=0&id=60c008cc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c008cc"]])

export default __exports__